import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import { font } from '@/shared/Activities/RealTimeActivity/Players/SortImagesActivity/sortImages.utils';
import styled from 'styled-components';

const commonGameAssetsFolder =
  process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST + '/commonGameAssets';

export const StyledAnswerDroppable = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border: 1px dashed ${Colors.border};
  background: white;
  color: ${Colors.lighterGray};
  display: flex;
  align-items: center;
  justify-content: center;

  &.empty {
    position: relative;
    background-color: #ffdd80;

    span {
      color: white;
      font-weight: ${font.weightBold};
      font-size: 18px;
      text-shadow: 0px 1px 2px #000000;
      z-index: 1;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-image: url('${commonGameAssetsFolder}/commonGameAssets/realTime/drag-here.png');
      background-position: center;
      background-size: contain;
      opacity: 0.6;
      z-index: 0;
    }

    .drag-text {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
  }

  &.disabled {
    opacity: 0.5;
  }

  .option {
    width: 100%;
    height: 100%;
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
    &.empty .drag-text {
      font-size: 14px;
    }
  }
`;
